import React, { useState } from "react";
import PropTypes from "prop-types";
import Alert from "shared/components/utils/icons/Alert";
import { Container, InputError, Label, TextField } from "./TextInput.styles";

const TextInput = (props) => {
    const { label, type, defaultValue } = props;

    const [value, setValue] = useState(defaultValue);

    function handleChange(e) {
        setValue(e.target.value);
        props.onChange(e);
    }

    return (
        <Container>
            <TextField
                type={type}
                value={value}
                onChange={handleChange}
                error={!!(props.className && props.className.includes("error") > 0)}
            />
            <Label filled={!!(value && value.length > 0)}>
                {label}
            </Label>
            {props.className?.includes("error") && (
                <InputError>
                    <Alert />
                </InputError>
            )}
        </Container>
    );
};

TextInput.defaultProps = {
    defaultValue: "",
};

TextInput.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
};

export default TextInput;
